// extracted by mini-css-extract-plugin
module.exports = {"cameraContainer":"styles_cameraContainer__3CXbo","placeholder":"styles_placeholder__1fn93","status":"styles_status__2-626"};